export default __webpack_public_path__ + "static/media/Email campaign-pana.dce98f48.svg";